module.exports = __webpack_public_path__ + "img/answer-block.3c98f2b2.webp";